<template>
  <div>
    <SatinalmaTopContent :gelentur="tur" @baslangic="getName" @bitis="bitis" @aranan="aranan"
      @secilenDurum="secilenDurum" />
    <b-row>


      <b-col cols="12" class="mb-1">
        <b-row align-h="start">
          <b-col cols="12" md="auto"> <vs-button line-origin="left" color="danger" type="gradient"
              style="font-weight: bold; border-radius: 5px; padding-bottom: 7px"><download-excel class="btn btn-default"
                :data="rowData" name="excelData.xls" style="
                  font-weight: bold;
                  width: 75px;
                  height: 25px;
                  text-align: center;
                  padding: 0px;
                  color: white;
                ">
                Excel
              </download-excel></vs-button>
          </b-col>


        </b-row>

      </b-col>
      <ag-grid-vue style="width: 100%; height: 500px" class="ag-theme-alpine" :defaultColDef="defaultColDef"
        :columnDefs="columnDefs" :rowSelection="rowSelection" :rowData="rowData" :localeText="localeText"
        :pagination="true" :pinnedBottomRowData="pinnedBottomRowData" :suppressCopyRowsToClipboard="true"
        @grid-ready="onGridReady" @first-data-rendered="onFirstDataRendered" @filter-changed="onFilterChanged"
        @filter-modified="onFilterModified">
      </ag-grid-vue>
    </b-row>
  </div>
</template>
<script>
import Store from "../../store/store";
import state from "../../store/state";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import SatinalmaTopContent from "../components/crm-components/satinalma-components/SatinalmaTopContent.vue";
import IadeArizaDetayButon from "../components/crm-components/satinalma-components/IadeArizaDetayButon.vue";
import TextGorunumCellRenderer from "./CellRenderers/TextGorunumCellRenderer.vue"
import moment from "moment";

export default {
  data() {
    return {
      pinnedBottomRowData: null,
      tur: "Ariza",
      localeText: null,
      rowSelection: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columnDefs: null,
      rowData: null,
      secilenDurumVal: "",
      bitisVal: "",
      arananVal: "",
      baslangicVal: "",

      gelenfiltre: "",

      toplamAdet: 0,
      topTOTAL: 0.0,
      topAraToplam: 0.0,
      topVatToplam: 0.0,
    };
  },
  components: {
    SatinalmaTopContent,
    AgGridVue,
    IadeArizaDetayButon,
    TextGorunumCellRenderer
  },
  created() {
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
    this.rowSelection = "single";
    this.satinAlma();
  },
  methods: {
    onFilterChanged(e) {
      let list = [];
      this.gridApi.forEachNodeAfterFilter((node) => {
        list.push(node.data);
      });
      this.toplamAdet = 0;
      this.topTOTAL = 0.0;
      list.forEach((val, index) => {
        this.toplamAdet += val.ADET;
        this.topTOTAL += val.TOTAL;
        this.topAraToplam += val.PRODUCTSUM;
        this.topVatToplam += val.VATSUM;
      });

      this.pinnedBottomRowData = this.createData(1, "Bottom");
    },
    onFilterModified(e) {
      if (e.filterInstance.getModelFromUi() == null) console.log("in");
      else this.gelenfiltre = e.filterInstance.getModelFromUi().filter;
    },
    secilenDurum(value) {
      this.secilenDurumVal = value;
      // this.satinAlma();
    },
    aranan(value) {
      this.arananVal = value;
      if (value != "") this.satinAlma();
    },
    arananfiltre(value) {
      this.arananfiltreVal = value;
      this.satinAlma();
    },
    bitis(value) {
      this.bitisVal = value;
      // this.satinAlma();
    },

    getName(value) {
      this.baslangicVal = value;
      //  this.satinAlma();
    },
    ilkkayit(value) {
      console.log("ilkkayit")

      this.ilkkayitVal = value;
      //  this.satinAlma();
    },
    sonkayit(value) {
      console.log("sonkayit")

      this.sonkayitVal = value;
      this.satinAlma();
    },

    currencyFormatter(currency, sign) {
      if (currency == "") {
        return "";
      } else {
        var sansDec = currency.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return sign + `${formatted}`;
      }
    },

    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    getLastTreeMonth() {
      var d = new Date();
      d.setMonth(d.getMonth() - 3);
      return d.toLocaleDateString();
    },
    createData(count, prefix) {
      var result = [];

      result.push({
        ISLEM: "",
        ACTNAME: "",
        RECEIPTNO: "",
        TARIH: "",
        VADE: "",
        PRODUCTSUM: this.topAraToplam,
        ADET: this.toplamAdet,
        STOCKNO: "",
        STOCKNAME: "",
        VATSUM: this.topVatToplam,
        TOTAL: this.topTOTAL,
        SPECCODE1: "",
        SONDURUM: "",
        SONACIKLAMA: "",
      });
      return result;
    },
    getLastTreeMonth() {
      var d = new Date();
      d.setMonth(d.getMonth() - 2);
      return new Date(d);
    },
    getNow() {
      const today = new Date();
      const date =
        today.getMonth() +
        1 +
        "." +
        today.getDate() +
        "." +
        today.getFullYear();

      const dateTime = date;
      return dateTime;
    },
    satinAlma() {
      var vm = this;
      const vs = this.$vs;
      setTimeout(() => {
        vs.loading({
          background: "#0064fa",
          color: "#fff",
          container: "#button-with-loading-iadearizalist",
          scale: 0.45
        });
      }, 500)

      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {
        token: Store.state.tokenId,
        ILKTARIH: vm.baslangicVal == "" ? moment(String(vm.getLastTreeMonth())).format("MM.DD.YYYY") : vm.baslangicVal,
        SONTARIH: vm.bitisVal == "" ? vm.getNow() : vm.bitisVal,
        ARANAN: vm.arananVal,
        STATUS: vm.secilenDurumVal == "" ? "2" : vm.secilenDurumVal,
      };
      console.log(args)

      soap.createClient(url, function (err, client) {
        client.INT_IadeArizaListesi(args, function (err, result) {
          if (result.INT_IadeArizaListesiResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_IadeArizaListesiResult);
            vm.rowData = vm.veriler;
            vm.rowData.forEach((val, index) => {
              vm.toplamAdet += val.ADET;
              vm.topTOTAL += val.TOTAL;
              vm.topAraToplam += val.PRODUCTSUM;
              vm.topVatToplam += val.VATSUM;
            });
            vm.pinnedBottomRowData = vm.createData(1, "Bottom");

            setTimeout(() => {
              vs.loading.close("#button-with-loading-iadearizalist > .con-vs-loading");
            }, 1000)
          } catch (error) {
            setTimeout(() => {
              vs.loading.close("#button-with-loading-iadearizalist > .con-vs-loading");
            }, 1000)
          }
        });
      });
    },
  },

  beforeMount() {
    this.columnDefs = [
      {
        width: 150,
        field: "",
        cellRendererFramework: "IadeArizaDetayButon",
      },
      {
        headerName: "İşlem",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        field: "ISLEM",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Durum",
        field: "SPECCODE1",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Tarih",
        field: "TARIH",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "İrsaliye No",
        field: "RECEIPTNO",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Tedarikçi Adı",
        field: "DELIVERYNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },

      },
      {
        headerName: "Müşteri Adı",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },

      },
      {
        headerName: "Ürün Stok Kodu",
        field: "STOCKNO",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Ürün Stok Adı",
        field: "STOCKNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },

      },
      {
        headerName: "Ürün Adeti",
        field: "ADET",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Ara Toplam",
        field: "PRODUCTSUM",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: (params) =>
          this.currencyFormatter(params.data.PRODUCTSUM, "₺"),
      },
      {
        headerName: "Kdv Toplam",
        field: "VATSUM",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: (params) =>
          this.currencyFormatter(params.data.VATSUM, "₺"),
      },
      {
        headerName: "Toplam",
        field: "TOTAL",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: (params) =>
          this.currencyFormatter(params.data.TOTAL, "₺"),
      },
      {
        headerName: "Son Durum",
        field: "SONDURUM",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Son Açıklama",
        field: "SONACIKLAMA",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
      },
    ];
  },
};
</script>